export enum DeletedEnum {
	NORMAL, DELETED,
}
